import { createSlice } from "@reduxjs/toolkit";
import {
  deleteGalleryImg,
  getGalleryImg,
  getGalleryImgCategory,
  undoDeleteGalleryImg,
} from "./PhotoGallery.api";

const photogallerySlice = createSlice({
  name: "photogallery",
  initialState: {
    photogallery: [],
    photoGalleryCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getGalleryImg.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getGalleryImg.fulfilled, (state, action) => {
      state.loading = false;
      state.photogallery = action.payload;
      state.dataLimit = action.payload.meta?.limit || 10;
      state.currentPage = action.payload.meta?.page || 1;
      state.totalPages = action.payload.meta?.totalPages || 0;
      state.totalData = action.payload.meta?.total || 0;
    });
    builder.addCase(getGalleryImg.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getGalleryImgCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getGalleryImgCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.photoGalleryCategory = action.payload;
    });
    builder.addCase(getGalleryImgCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteGalleryImg.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteGalleryImg.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.photogallery.data) {
        state.photogallery.data = state.photogallery.data.filter(
          (photogallery) => {
            return photogallery._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.photogallery.data is not an array:",
          state.photogallery.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteGalleryImg.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteGalleryImg.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteGalleryImg.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.photogallery.data) {
        state.photogallery.data = state.photogallery.data.filter(
          (photogallery) => {
            return photogallery._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.photogallery.data is not an array:",
          state.photogallery.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteGalleryImg.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = photogallerySlice.actions;
export default photogallerySlice.reducer;
